import { moduleProviderFactory } from 'core/providers';
import { ProductList, ProductEdit, ProductDetail, ProductHistoryLogList, ProductActivity } from 'modules/product/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.product',
				pattern: '/products',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.product.list',
						pattern: '',
						component: ProductList,
					},
					{
						name: 'master.app.main.product.list.history-log',
						pattern: '/history-log',
						component: ProductHistoryLogList,
					},
					{
						name: 'master.app.main.product.list.history-log-item',
						pattern: '/history-log/:id',
						component: ProductHistoryLogList,
					},
					{
						name: 'master.app.main.product.list.edit',
						pattern: '/edit/:id',
						authorization: ['productSection.full'],
						component: ProductEdit,
					},
					{
						name: 'master.app.main.product.list.detail',
						pattern: '/detail/:id',
						component: ProductDetail,
					},
					{
						name: 'master.app.main.product.list.add',
						pattern: '/add',
						authorization: ['productSection.full'],
						component: ProductEdit,
					},
					{
						name: 'master.app.main.product.list.activity',
						pattern: '/product-activity/:id',
						component: ProductActivity,
					},
				],
			},
		],
	});
})();
